



































































import {
  faExclamationTriangle,
  faTrash
} from '@fortawesome/free-solid-svg-icons'
import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import CProgressBar from '~/components/shared/configurable/progress-bar/CProgressBar.vue'
import { UploaderFile } from '~/models/photos/uploader'

export default defineComponent({
  components: { CProgressBar },
  props: {
    file: {
      type: Object as PropType<UploaderFile>,
      required: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: false
    },
    titleInputPlaceholder: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const { file, draggable } = toRefs(props)

    const icons = {
      exclamationTriangle: faExclamationTriangle,
      trash: faTrash
    }

    function handleDeleteClick() {
      emit('delete')
    }

    function handleTitleInput(title: string) {
      emit('title-change', title)
    }

    const classes = computed(() => {
      const cursorClasses = () => (draggable.value ? ['tw-cursor-grab'] : [])
      const backgroundClasses = () =>
        file.value.error ? ['tw-bg-red-100'] : ['tw-bg-grey-50']
      const borderClasses = () =>
        file.value.error ? ['tw-border-red-300'] : ['tw-border-grey-300']

      return [...backgroundClasses(), ...cursorClasses(), ...borderClasses()]
    })

    return { handleDeleteClick, icons, classes, handleTitleInput }
  }
})
